import request from '../../../request/actions';

export const GET_USER_PREFERENCES_START = `GET_USER_PREFERENCES_START`;
export const GET_USER_PREFERENCES_SUCCESS = `GET_USER_PREFERENCES_SUCCESS`;
export const GET_USER_PREFERENCES_FAILURE = `GET_USER_PREFERENCES_FAILURE`;

export const getUserPreferencesStart = () => ({
  type: GET_USER_PREFERENCES_START,
});

export const getUserPreferencesSuccess = (preferences) => ({
  type: GET_USER_PREFERENCES_SUCCESS,
  preferences,
});

export const getUserPreferencesFailure = (error) => ({
  type: GET_USER_PREFERENCES_FAILURE,
  error,
});

/**
 * Description of the getUserPreferences action
 */
export const getUserPreferences = (id) => async (dispatch) => {
  dispatch(getUserPreferencesStart());
  try {
    const response = await dispatch(request(`/users/${id}/preferences/`, `GET`));
    dispatch(getUserPreferencesSuccess(response.data.preferences));
    return response.data;
  } catch (error) {
    dispatch(getUserPreferencesFailure(error));
    return error.response;
  }
};

export default getUserPreferences;
